import question from './modules/question';
import user from './modules/user';
import post from './modules/post';
import pack from './modules/pack';
import userAnswer from './modules/userAnswer';
import contact from './modules/contact';
import notion from './modules/notion';
import vision from './modules/vision';
import theme from './modules/theme';
import offer from './modules/offer';
import app from './modules/app';
import loading from './modules/loading';
import violation from './modules/violation';

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        user,
        question,
        post,
        pack,
        userAnswer,
        contact,
        notion,
        vision,
        theme,
        offer,
        app,
        loading,
        violation,
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js